var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('patientSelect',{on:{"onConfirm":_vm.patientConfirm}}),_c('load-more',{attrs:{"data-source":_vm.dataList,"total":_vm.total,"loading":_vm.loading},on:{"load-more":_vm.onLoad}},[_c('appointment-item',{attrs:{"data":_vm.dataList,"type":"2"},on:{"refresh":_vm.refresh}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }